// extracted by mini-css-extract-plugin
export default {"zoomedIframe":"SPKEmployerCandidatesList_zoomedIframe__wg6-+"};